export default async function staffFetch(url, options = {}) {
  const token = localStorage.getItem("evoAccessToken");

  if (!token) {
    throw new Error("Session Staff introuvable.");
  }

  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`
    }
  });
}
